export default __webpack_public_path__ + "static/media/DJI_0971.MP4.00_03_57_15.Still001.36a1c1dc.jpg";